export const BATCH_WHATSAPP_GENERATED_USER_MESSAGE = 'BATCH_WHATSAPP_GENERATED_USER_MESSAGE';